export default __webpack_public_path__ + "static/media/product-vector-1.480f26ac.png";